module.exports = __webpack_public_path__ + "assets/img/yanjiuhuixinxi@2x.a4dbf60c.png";